import React from 'react';
import Typography from '@material-ui/core/Typography';
import CreditCardDetail from 'Components/CreditCard/CreditCardDetail';

class CardSection extends React.Component {
  render() {
    return (
      <label>
        <Typography variant="h5" style={{ marginBottom: 20 }}>
          Card Details
        </Typography>
        <CreditCardDetail />
      </label>
    );
  }
}

export default CardSection;
